import { GridSortModel } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../../hooks/use-encounter-creation-gate";
import { PatientFamilyHistoryControllerApi } from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  patientUuid?: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortModel;
  status?: boolean;
  archive?: boolean;
  searchString?: string;
  appointmentUuid?: string;
  xTENANTID?: string | undefined;
  enabled?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const usePastFamilyHistoryList = ({
  patientUuid,
  pagination,
  gridSorting,
  status,
  archive,
  searchString,
  appointmentUuid,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortData = gridSorting?.[0];
  const skip = useEncounterCreationGate();

  return useQuery({
    queryKey: [
      "patient-family-history-list",
      patientUuid,
      pageIndex,
      pageSize,
      gridSorting,
      sortData,
      status,
      archive,
      appointmentUuid,
      searchString,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new PatientFamilyHistoryControllerApi(getConfigObject())
        .getPatientFamilyHistory(
          patientUuid,
          pageIndex, //page
          pageSize, //size
          sortData?.field,
          sortData?.sort ?? undefined, // sortDirection
          status,
          appointmentUuid,
          undefined, //providerStatus
          archive,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
    enabled: enabled && !skip,
  });
};
